import React from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { path: '/', label: 'Search' },
  { path: '/patent', label: 'Patent' },
  { path: '/history', label: 'History' }
];

function NavLink({ to, isActive, isMobile, children }) {
  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-lg ${
        isMobile ? 'text-sm' : 'text-base'
      } font-medium transition-colors ${
        isActive
          ? 'text-white'
          : 'text-gray-300 hover:text-white hover:bg-gray-800/50'
      }`}
    >
      {children}
    </Link>
  );
}

export default function Navigation({ currentPath, isMobile = false }) {
  const isLinkActive = (path) => {
    if (path === '/') {
      return currentPath === '/';
    }
    if (path === '/patent') {
      return currentPath === '/patent';
    }
    if (path === '/analyze') {
      return currentPath === '/analyze' || currentPath.startsWith('/analyze');
    }
    return currentPath.startsWith(path);
  };

  return (
    <nav
      className={`${
        isMobile
          ? 'md:hidden flex gap-4'
          : 'hidden md:flex gap-12'
      } items-center flex-1 justify-center`}
    >
      {NAV_LINKS.map((link) => (
        <NavLink
          key={link.path}
          to={link.path}
          isActive={isLinkActive(link.path)}
          isMobile={isMobile}
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}

